<script setup lang="ts">
import type { SkeletonProps } from "./skeleton.types";
import { useSkeleton } from "./useSkeleton";

defineOptions({ name: "ESkeleton" });

const props = withDefaults(defineProps<SkeletonProps>(), {
  variant: "line",
  animated: true,
});

const { classes } = useSkeleton({ props });
</script>

<template>
  <div :class="classes" class="e-skeleton" part="skeleton" role="presentation" aria-hidden="true" />
</template>

<style>
:host {
  display: contents;
}
</style>
